"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BenchmarkSimple = void 0;
const BenchmarkBase_1 = require("./BenchmarkBase");
class BenchmarkSimple extends BenchmarkBase_1.BenchmarkBase {
    createStartFunctionCode(code) {
        return `
            var __timeBefore = Date.now();
            ${code}
            var __timeAfter = Date.now();
            return __timeAfter - __timeBefore;
        `;
    }
}
exports.BenchmarkSimple = BenchmarkSimple;
//# sourceMappingURL=BenchmarkSimple.js.map